module.exports = __webpack_public_path__ + "static/media/pic-5.b81391bc.jpg";